import { postRequest, patchRequest, deleteRequest } from '@helpers/request'
import { logger } from '@helpers/logger'

// Function to post a new user
export const postUser = async () => {
  // Check both URL parameters and sessionStorage for invite parameter
  const urlParams = new URLSearchParams(window.location.search)
  const urlInviteParam = urlParams.get('invite')
  const storedInviteParam = sessionStorage.getItem('inviteParam')

  // Use stored invite parameter if URL doesn't have it
  const inviteParam = urlInviteParam || storedInviteParam

  console.log('INVITE_LOGS: userService.postUser - urlInviteParam:', urlInviteParam, 'storedInviteParam:', storedInviteParam, 'final inviteParam:', inviteParam)

  const data = {
    entryKey: inviteParam,
    frontendDomain: window.location.origin,
  } // Define the data object

  try {
    const { response, logComplete } = await postRequest('user', data) // Call the postRequest helper function
    logComplete() // Call the completion logging function

    // Clear the stored invite parameter after successful user creation
    if (storedInviteParam) {
      sessionStorage.removeItem('inviteParam')
      console.log('INVITE_LOGS: userService: Cleared stored invite parameter after user creation')
    }

    return response // Return the response data
  } catch (error) {
    logger.error('postUser', error) // Log the error
  }
}

// Function to update user information
export const patchUser = async (userData, setUserDoc) => {
  try {
    const { response, logComplete } = await patchRequest('user', userData) // Call the patchRequest helper function

    logger.log('User profile updated successfully')
    // Use the returned user object to update local state
    setUserDoc(response.user) // Update the user document

    logComplete() // Call the completion logging function
    return response.user // Return the updated user data
  } catch (error) {
    logger.error('patchUser', error.message) // Log the error
  }
}

// Function to update user login information
export const updateUserLogin = async () => {
  try {
    await patchRequest('userLogin')

    logger.log('User login information updated successfully')
  } catch (error) {
    logger.error('updateUserLogin', error.message)
  }
}

// Function to delete user account and all associated data
export const deleteUser = async () => {
  try {
    const { response, logComplete } = await deleteRequest('user')

    logger.log('User account deleted successfully')
    logComplete()
    return response
  } catch (error) {
    logger.error('deleteUser', error.message)
    throw error // Re-throw to allow caller to handle the error
  }
}
